import { differenceInCalendarDays, format, parseISO } from 'date-fns'
import { id } from 'date-fns/locale'

export const FORMAT_DATE_DEFAULT = 'd MMMM yyyy'
export const FORMAT_DATE_DATEPICKER = 'yyyy-MM-dd'
export const FORMAT_DATE_TIME_WIB = 'd MMM yyyy, HH:mm'

export const formatDate = (
  date: Date | string | number,
  dateFormat = FORMAT_DATE_DEFAULT
) => {
  try {
    return format(new Date(date), dateFormat, {
      locale: id,
    })
  } catch {
    return date
  }
}

export const formatDateTimeWIB = (date: Date | string | number) => {
  try {
    return format(new Date(date), FORMAT_DATE_TIME_WIB, { locale: id }) + ' WIB'
  } catch {
    return String(date)
  }
}

export function countDaysInclusive(startDate?: string, endDate?: string) {
  if (!startDate || !endDate) return 0
  const start = parseISO(startDate)
  const end = parseISO(endDate)
  return differenceInCalendarDays(end, start) + 1
}
